var _g, _rect, _path, _path2, _path3, _g2, _circle, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStellarclub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 62,
    viewBox: "0 0 142 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_321_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3752 31.4376C48.3752 41.2062 40.4562 49.1252 30.6876 49.1252C20.919 49.1252 13 41.2062 13 31.4376C13 21.669 20.919 13.75 30.6876 13.75C40.4562 13.75 48.3752 21.669 48.3752 31.4376ZM14.5236 31.4376C14.5236 40.3647 21.7605 47.6015 30.6876 47.6015C39.6147 47.6015 46.8515 40.3647 46.8515 31.4376C46.8515 22.5105 39.6147 15.2736 30.6876 15.2736C21.7605 15.2736 14.5236 22.5105 14.5236 31.4376Z",
    fill: "#9979F7"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_4067)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.459,
    y: 16.3008,
    width: 30.3058,
    height: 30.3058,
    rx: 15.1529,
    fill: "url(#paint0_radial_321_4067)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5983 43.8047C33.7777 44.0931 32.9333 44.3741 32.0661 44.6476H28.8145C27.9473 44.3741 27.1029 44.0931 26.2822 43.8047H34.5983ZM38.9124 42.1274H21.9682C21.328 41.8515 20.7077 41.5704 20.1078 41.2845H40.7727C40.1729 41.5704 39.5525 41.8515 38.9124 42.1274ZM45.329 38.7644C44.8911 39.0488 44.4344 39.3298 43.9595 39.6072H16.9211C16.4462 39.3298 15.9895 39.0488 15.5516 38.7644H45.329ZM47.6428 37.087H13.2378C12.8967 36.8087 12.5731 36.5277 12.2672 36.2442H48.6133C48.3075 36.5277 47.9838 36.8087 47.6428 37.087ZM50.813 33.724C50.6226 34.0067 50.415 34.2877 50.1903 34.5669H10.6902C10.4656 34.2877 10.2579 34.0067 10.0675 33.724H50.813ZM51.7301 32.0467H9.15049C9.03256 31.7671 8.93129 31.4861 8.84693 31.2038H52.0336C51.9493 31.4861 51.848 31.7671 51.7301 32.0467ZM52.3333 29.5265H8.5473C8.53898 29.3863 8.5348 29.2458 8.5348 29.105C8.5348 28.9642 8.53897 28.8238 8.54728 28.6837H52.3333C52.3416 28.8238 52.3458 28.9642 52.3458 29.105C52.3458 29.2458 52.3416 29.3863 52.3333 29.5265ZM52.0337 27.0063H8.84685C8.9312 26.7241 9.03246 26.4431 9.15037 26.1635H51.7302C51.8481 26.4431 51.9494 26.7241 52.0337 27.0063ZM50.8132 24.4862H10.0674C10.2578 24.2035 10.4654 23.9225 10.69 23.6433H50.1906C50.4152 23.9225 50.6228 24.2035 50.8132 24.4862ZM48.6136 21.966H12.267C12.5728 21.6825 12.8964 21.4015 13.2375 21.1232H47.6431C47.9841 21.4015 48.3078 21.6825 48.6136 21.966ZM45.3294 19.4458H15.5512C15.9891 19.1614 16.4457 18.8803 16.9206 18.603H43.9599C44.4349 18.8803 44.8915 19.1614 45.3294 19.4458ZM40.7733 16.9256H20.1073C20.7071 16.6397 21.3274 16.3587 21.9676 16.0828H38.913C39.5531 16.3587 40.1734 16.6397 40.7733 16.9256ZM34.5991 14.4055H26.2815C27.1021 14.1171 27.9465 13.836 28.8136 13.5626H32.0669C32.9341 13.836 33.7784 14.1171 34.5991 14.4055Z",
    stroke: "url(#paint1_linear_321_4067)",
    strokeWidth: 0.417247
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.1535 48.0048C40.6206 48.0048 48.2952 40.5628 48.2952 31.3825C48.2952 22.2023 40.6206 14.7603 31.1535 14.7603C21.6863 14.7603 14.0117 22.2023 14.0117 31.3825C14.0117 40.5628 21.6863 48.0048 31.1535 48.0048Z",
    fill: "#AE9AFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_321_4067",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 35,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1535 48.0048C40.6206 48.0048 48.2952 40.5628 48.2952 31.3825C48.2952 22.2023 40.6206 14.7603 31.1535 14.7603C21.6863 14.7603 14.0117 22.2023 14.0117 31.3825C14.0117 40.5628 21.6863 48.0048 31.1535 48.0048Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_321_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7101 30.8192C34.7576 31.9369 33.83 33.0389 33.83 33.0389C33.83 33.0389 34.6455 34.2964 34.313 36.074C33.9808 37.8512 32.9278 39.0545 32.9278 39.0545C32.9278 39.0545 32.8402 38.0093 32.6017 37.4259C32.3638 36.8424 31.4239 35.6879 31.4239 35.6879C31.4239 35.6879 30.9979 36.1905 30.505 36.2148C30.3186 36.2237 30.0192 36.0828 29.6696 35.8692C29.6282 35.9297 29.5857 35.99 29.5418 36.0497C28.1697 37.9297 26.258 38.9051 25.2724 38.2288C24.2866 37.5519 24.5998 35.4798 25.9723 33.5999C26.0303 33.52 26.0894 33.4429 26.1496 33.3667C25.7647 33.0523 25.4851 32.7634 25.4667 32.5606C25.4248 32.0987 25.6419 31.783 25.6419 31.783C25.6419 31.783 24.723 31.4106 23.8039 31.386C22.885 31.3615 21.9238 31.6288 21.9238 31.6288C21.9238 31.6288 22.8095 30.1705 24.2551 29.3927C25.7006 28.6149 27.5304 28.6473 27.5304 28.6473C27.5304 28.6473 28.3657 27.2458 28.767 26.5896L28.813 26.514C29.2295 25.8285 30.0573 24.466 32.1174 23.3893C34.2561 22.2713 36.8129 22.4414 36.8129 22.4414C36.8129 22.4414 37.4979 24.3208 37.4979 26.2655C37.4979 28.21 36.6626 29.7008 35.7101 30.8192ZM32.9525 25.6406C31.8218 25.6406 30.9052 26.5292 30.9052 27.6256C30.9052 28.7219 31.8218 29.6106 32.9525 29.6106C34.0827 29.6106 34.9994 28.7219 34.9994 27.6256C34.9995 26.5292 34.0829 25.6406 32.9525 25.6406ZM26.2515 36.8607C25.5611 36.3665 25.7388 34.9985 26.6475 33.8054C26.6492 33.8031 26.651 33.8009 26.6528 33.7987C26.6548 33.7963 26.6568 33.7938 26.6587 33.7912C26.9051 33.9699 27.1615 34.1477 27.4024 34.3147C27.5206 34.3967 27.6351 34.4761 27.7429 34.5517C27.9174 34.6746 28.1057 34.8116 28.2997 34.9527C28.5848 35.1601 28.882 35.3763 29.165 35.5692C29.162 35.5732 29.1592 35.5772 29.1565 35.5812C29.1532 35.5859 29.1499 35.5906 29.1463 35.5953C28.2372 36.7886 26.9414 37.3547 26.2515 36.8607Z",
    fill: "#AE9AFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.627 43.5293L21.3981 39.9634C21.5469 39.7718 21.8265 39.7325 22.0224 39.8757V39.8757C22.2183 40.0188 22.2564 40.2902 22.1075 40.4818L19.3364 44.0477L18.627 43.5293Z",
    fill: "#AE9AFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0957 44.6426L21.8944 42.3279C22.0433 42.1363 22.3229 42.097 22.5188 42.2402V42.2402C22.7147 42.3834 22.7528 42.6547 22.6039 42.8463L20.8052 45.161L20.0957 44.6426Z",
    fill: "#AE9AFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.612,
    cy: 31.4528,
    r: 16.7311,
    fill: "url(#paint2_radial_321_4067)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter1_i_321_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3752 31.4376C48.3752 41.2062 40.4562 49.1252 30.6876 49.1252C20.919 49.1252 13 41.2062 13 31.4376C13 21.669 20.919 13.75 30.6876 13.75C40.4562 13.75 48.3752 21.669 48.3752 31.4376ZM14.5236 31.4376C14.5236 40.3647 21.7605 47.6015 30.6876 47.6015C39.6147 47.6015 46.8515 40.3647 46.8515 31.4376C46.8515 22.5105 39.6147 15.2736 30.6876 15.2736C21.7605 15.2736 14.5236 22.5105 14.5236 31.4376Z",
    fill: "url(#paint3_radial_321_4067)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3752 31.4376C48.3752 41.2062 40.4562 49.1252 30.6876 49.1252C20.919 49.1252 13 41.2062 13 31.4376C13 21.669 20.919 13.75 30.6876 13.75C40.4562 13.75 48.3752 21.669 48.3752 31.4376ZM13.2908 31.4376C13.2908 41.0456 21.0796 48.8344 30.6876 48.8344C40.2956 48.8344 48.0844 41.0456 48.0844 31.4376C48.0844 21.8296 40.2956 14.0408 30.6876 14.0408C21.0796 14.0408 13.2908 21.8296 13.2908 31.4376Z",
    fill: "url(#paint4_linear_321_4067)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1424 27.0026C56.7443 27.0026 55.2113 25.5607 55.0898 23.3598H56.6228C56.7443 24.7259 57.6398 25.6062 59.1424 25.6062C60.4781 25.6062 61.4495 25.0901 61.4495 23.9366C61.4495 21.3867 55.4238 22.9197 55.4238 19.0037C55.4238 17.3038 56.9112 16.1351 59.0513 16.1351C61.2218 16.1351 62.7092 17.3948 62.8459 19.3376H61.3129C61.2066 18.2448 60.3566 17.5314 59.0513 17.5314C57.7764 17.5314 57.0023 18.1082 57.0023 19.0037C57.0023 21.584 63.0583 19.8689 63.0583 23.9214C63.0583 25.8642 61.4191 27.0026 59.1424 27.0026Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3634 16.8332H66.8357V19.2314H69.0972V20.5063H66.8357V24.3312C66.8357 25.1508 67.2758 25.6062 68.0196 25.6062H69.0972V26.8811H67.8981C66.35 26.8811 65.3634 25.9401 65.3634 24.3768V20.5063H63.8001V19.2314H65.3634V16.8332Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.639 24.3919H77.1113C76.838 25.9705 75.4568 27.0026 73.5748 27.0026C71.207 27.0026 69.7347 25.1357 69.7347 23.0107C69.7347 20.8706 71.0704 19.11 73.423 19.11C75.7908 19.11 77.0505 20.7947 77.0505 22.7375C77.0505 22.9348 77.0354 23.1777 77.0202 23.3143H71.1766C71.298 24.7562 72.2391 25.7428 73.5748 25.7428C74.6979 25.7428 75.4265 25.2571 75.639 24.3919ZM73.423 20.2939C72.2239 20.2939 71.4498 20.9617 71.2221 22.2367H75.5631C75.472 21.0679 74.6828 20.2939 73.423 20.2939Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6254 26.8811V16.0288H80.0977V26.8811H78.6254Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1235 26.8811V16.0288H83.5957V26.8811H82.1235Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4472 19.11C90.4203 19.11 91.7256 20.2483 91.7256 21.9483V26.8811H90.2533V25.6365C89.8891 26.4562 88.9177 27.0026 87.7641 27.0026C86.2008 27.0026 85.1687 26.0615 85.1687 24.6955C85.1687 23.2232 86.3374 22.3125 88.1436 22.3125H89.7373C90.0864 22.3125 90.2533 22.1304 90.2533 21.8572C90.2533 20.9313 89.5855 20.2939 88.4016 20.2939C87.3392 20.2939 86.5651 20.9617 86.5195 21.7358H85.1535C85.2749 20.2331 86.641 19.11 88.4472 19.11ZM88.0525 25.8339C89.4489 25.8339 90.2533 24.9384 90.2533 23.5268V23.3447H88.2802C87.2784 23.3447 86.6258 23.8607 86.6258 24.6651C86.6258 25.3633 87.2025 25.8339 88.0525 25.8339Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8631 20.5063H96.7551C95.3588 20.5063 94.9034 21.751 94.9034 23.4205V26.8811H93.4311V19.2314H94.9034V20.7037C95.2525 19.6867 95.8596 19.2314 96.9373 19.2314H97.8631V20.5063Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8372,
    y: 30.7927,
    width: 86.4165,
    height: 16.3066,
    rx: 8.15332,
    fill: "url(#paint5_linear_321_4067)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6151 42.6634C60.4297 42.6634 58.8125 41.0025 58.8125 38.7516C58.8125 36.5006 60.4297 34.8397 62.6151 34.8397C64.7896 34.8397 66.4068 36.5006 66.4068 38.7516C66.4068 41.0025 64.7896 42.6634 62.6151 42.6634ZM62.6151 41.6581C64.134 41.6581 65.2485 40.4234 65.2485 38.7516C65.2485 37.0797 64.134 35.845 62.6151 35.845C61.0963 35.845 59.9708 37.0797 59.9708 38.7516C59.9708 40.4234 61.0963 41.6581 62.6151 41.6581Z",
    fill: "#696767"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5259 42.576V37.0688H68.5858V38.0413C68.8808 37.3529 69.5364 36.9814 70.356 36.9814C71.6017 36.9814 72.4103 37.8774 72.4103 39.1886V42.576H71.3503V39.3962C71.3503 38.5221 70.8368 37.932 70.0609 37.932C69.1977 37.932 68.5858 38.6314 68.5858 39.5929V42.576H67.5259Z",
    fill: "#696767"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6094 42.6634C75.8773 42.6634 75.1998 42.3028 74.8829 41.7565V42.576H73.823V34.7632H74.8829V37.8774C75.1998 37.342 75.8664 36.9814 76.6203 36.9814C78.3031 36.9814 79.2537 38.1833 79.2537 39.8224C79.2537 41.4615 78.3031 42.6634 76.6094 42.6634ZM76.4892 41.7346C77.5054 41.7346 78.1829 40.9697 78.1829 39.8224C78.1829 38.6751 77.5054 37.9102 76.4892 37.9102C75.4621 37.9102 74.7955 38.6751 74.7955 39.8224C74.7955 40.9697 75.4621 41.7346 76.4892 41.7346Z",
    fill: "#696767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8231 42.6634C81.1731 42.6634 79.9821 41.4724 79.9821 39.8224C79.9821 38.1724 81.1731 36.9814 82.8231 36.9814C84.4731 36.9814 85.6532 38.1724 85.6532 39.8224C85.6532 41.4724 84.4731 42.6634 82.8231 42.6634ZM82.8231 41.7346C83.8612 41.7346 84.5714 40.9479 84.5714 39.8224C84.5714 38.6969 83.8612 37.9102 82.8231 37.9102C81.7741 37.9102 81.0639 38.6969 81.0639 39.8224C81.0639 40.9479 81.7741 41.7346 82.8231 41.7346Z",
    fill: "#696767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8117 36.9814C90.2322 36.9814 91.172 37.8009 91.172 39.0247V42.576H90.1121V41.68C89.8498 42.2701 89.1505 42.6634 88.32 42.6634C87.1945 42.6634 86.4515 41.986 86.4515 41.0025C86.4515 39.9426 87.2929 39.287 88.5932 39.287H89.7405C89.9919 39.287 90.1121 39.1559 90.1121 38.9592C90.1121 38.2926 89.6313 37.8337 88.779 37.8337C88.0141 37.8337 87.4568 38.3145 87.424 38.8717H86.4406C86.528 37.79 87.5114 36.9814 88.8117 36.9814ZM88.5276 41.822C89.5329 41.822 90.1121 41.1774 90.1121 40.1611V40.03H88.6915C87.9704 40.03 87.5005 40.4015 87.5005 40.9807C87.5005 41.4833 87.9157 41.822 88.5276 41.822Z",
    fill: "#696767"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5905 37.9867H94.7928C93.7876 37.9867 93.4597 38.8827 93.4597 40.0846V42.576H92.3998V37.0688H93.4597V38.1287C93.7111 37.3966 94.1481 37.0688 94.924 37.0688H95.5905V37.9867Z",
    fill: "#696767"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5581 42.6634C96.8645 42.6634 95.9138 41.4615 95.9138 39.8224C95.9138 38.1833 96.8645 36.9814 98.5472 36.9814C99.3012 36.9814 99.9677 37.342 100.296 37.8774V34.7632H101.355V42.576H100.296V41.7565C99.9677 42.3028 99.2903 42.6634 98.5581 42.6634ZM98.6783 41.7346C99.7055 41.7346 100.372 40.9697 100.372 39.8224C100.372 38.6751 99.7055 37.9102 98.6783 37.9102C97.6621 37.9102 96.9956 38.6751 96.9956 39.8224C96.9956 40.9697 97.6621 41.7346 98.6783 41.7346Z",
    fill: "#696767"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.685 34.7632H103.865V36.0963H102.685V34.7632ZM102.751 42.576V37.0688H103.811V42.576H102.751Z",
    fill: "#696767"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.152 42.576V37.0688H106.212V38.0413C106.507 37.3529 107.162 36.9814 107.982 36.9814C109.227 36.9814 110.036 37.8774 110.036 39.1886V42.576H108.976V39.3962C108.976 38.5221 108.462 37.932 107.687 37.932C106.823 37.932 106.212 38.6314 106.212 39.5929V42.576H105.152Z",
    fill: "#696767"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.514 37.0688H116.573V42.8383C116.573 43.9965 115.732 44.8051 114.53 44.8051H111.875V43.92H114.421C115.055 43.92 115.514 43.4392 115.514 42.7727V41.8767C115.251 42.3465 114.552 42.6634 113.776 42.6634C112.082 42.6634 111.132 41.4615 111.132 39.8224C111.132 38.1833 112.082 36.9814 113.765 36.9814C114.497 36.9814 115.175 37.3201 115.514 37.8009V37.0688ZM113.896 41.7346C114.924 41.7346 115.59 40.9807 115.59 39.8224C115.59 38.6641 114.924 37.9102 113.896 37.9102C112.88 37.9102 112.214 38.6641 112.214 39.8224C112.214 40.9807 112.88 41.7346 113.896 41.7346Z",
    fill: "#696767"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.158 42.5842H117.365V41.2346H118.158V42.5842Z",
    fill: "url(#paint6_linear_321_4067)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.745 42.6691C120.433 42.6691 119.348 41.5744 119.348 40.2342C119.348 38.9034 120.433 37.8086 121.745 37.8086C122.717 37.8086 123.566 38.4032 123.934 39.2621L123.217 39.6113C122.981 38.9978 122.415 38.5731 121.745 38.5731C120.858 38.5731 120.14 39.3187 120.14 40.2342C120.14 41.1496 120.858 41.9141 121.745 41.9141C122.415 41.9141 122.991 41.4894 123.227 40.8571L123.934 41.2063C123.566 42.0746 122.708 42.6691 121.745 42.6691Z",
    fill: "url(#paint7_linear_321_4067)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.798 42.5842H125.005V35.2227H125.798V42.5842Z",
    fill: "url(#paint8_linear_321_4067)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.207 42.6691C128.065 42.6691 127.225 41.8386 127.225 40.6966V37.903H128.018V40.7061C128.018 41.4045 128.518 41.9141 129.207 41.9141C129.905 41.9141 130.415 41.4045 130.415 40.7061V37.903H131.208V40.6966C131.208 41.8386 130.358 42.6691 129.207 42.6691Z",
    fill: "url(#paint9_linear_321_4067)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.864 37.8086C136.176 37.8086 137.252 38.9034 137.252 40.2436C137.252 41.5838 136.176 42.6691 134.864 42.6691C134.26 42.6691 133.769 42.4426 133.429 42.0179V42.5842H132.637V35.2227H133.429V38.4599C133.769 38.0351 134.26 37.8086 134.864 37.8086ZM134.836 41.9141C135.732 41.9141 136.459 41.1591 136.459 40.2436C136.459 39.3187 135.732 38.5731 134.836 38.5731C134.241 38.5731 133.703 38.9129 133.429 39.432V41.0553C133.703 41.5744 134.241 41.9141 134.836 41.9141Z",
    fill: "url(#paint10_linear_321_4067)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.189 42.5842H117.396V41.2346H118.189V42.5842Z",
    fill: "url(#paint11_linear_321_4067)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 42.6691C120.464 42.6691 119.379 41.5744 119.379 40.2342C119.379 38.9034 120.464 37.8086 121.776 37.8086C122.748 37.8086 123.597 38.4032 123.966 39.2621L123.248 39.6113C123.012 38.9978 122.446 38.5731 121.776 38.5731C120.889 38.5731 120.171 39.3187 120.171 40.2342C120.171 41.1496 120.889 41.9141 121.776 41.9141C122.446 41.9141 123.022 41.4894 123.258 40.8571L123.966 41.2063C123.597 42.0746 122.739 42.6691 121.776 42.6691Z",
    fill: "url(#paint12_linear_321_4067)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.829 42.5842H125.036V35.2227H125.829V42.5842Z",
    fill: "url(#paint13_linear_321_4067)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.238 42.6691C128.096 42.6691 127.256 41.8386 127.256 40.6966V37.903H128.049V40.7061C128.049 41.4045 128.549 41.9141 129.238 41.9141C129.936 41.9141 130.446 41.4045 130.446 40.7061V37.903H131.239V40.6966C131.239 41.8386 130.389 42.6691 129.238 42.6691Z",
    fill: "url(#paint14_linear_321_4067)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M134.895 37.8086C136.207 37.8086 137.283 38.9034 137.283 40.2436C137.283 41.5838 136.207 42.6691 134.895 42.6691C134.291 42.6691 133.8 42.4426 133.46 42.0179V42.5842H132.668V35.2227H133.46V38.4599C133.8 38.0351 134.291 37.8086 134.895 37.8086ZM134.867 41.9141C135.763 41.9141 136.49 41.1591 136.49 40.2436C136.49 39.3187 135.763 38.5731 134.867 38.5731C134.272 38.5731 133.734 38.9129 133.46 39.432V41.0553C133.734 41.5744 134.272 41.9141 134.867 41.9141Z",
    fill: "url(#paint15_linear_321_4067)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8372,
    y: 30.7927,
    width: 86.4165,
    height: 16.3066,
    rx: 8.15332,
    stroke: "#232323",
    strokeWidth: 0.50536
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_321_4067",
    x: 0.216671,
    y: 0.966671,
    width: 60.9417,
    height: 60.9417,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.39166,
    result: "effect1_foregroundBlur_321_4067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_321_4067",
    x: 13,
    y: 13.75,
    width: 35.375,
    height: 35.4785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.155206
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0517352
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_321_4067"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_4067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6119 31.4537) rotate(90) scale(15.1529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_4067",
    x1: 30.4392,
    y1: 19.0299,
    x2: 30.4392,
    y2: 42.2073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742212,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196118,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342856,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624111,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811143,
    stopColor: "#1F1F1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_321_4067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.612 31.4528) rotate(90) scale(16.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.637785,
    stopColor: "#060606",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08090B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_321_4067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6876 31.4376) rotate(90) scale(17.6876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.930858,
    stopColor: "#161616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_4067",
    x1: 19.9264,
    y1: 16.5568,
    x2: 47.7227,
    y2: 40.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A76A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#9B97C1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390278,
    stopColor: "#A6A2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859257,
    stopColor: "#9F9CC3",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_321_4067",
    x1: 59.1327,
    y1: 34.4951,
    x2: 132.41,
    y2: 44.6023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_321_4067",
    x1: 118.37,
    y1: 41.4159,
    x2: 140.435,
    y2: 41.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C74F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#F6B87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF4B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_4067"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.459,
    y: 16.3008,
    width: 30.3058,
    height: 30.3058,
    rx: 15.1529,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellarclub);
export default __webpack_public_path__ + "static/media/stellarclub.d998fe7580e0c9d9ebb8bedc72486d3b.svg";
export { ForwardRef as ReactComponent };